// Producao TAG
export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'tag';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'tag-web@tacom.com.br';
export const password = 'M@PPDb8F63';

export const versaoSoftware = '4.4.16';
export const idioma = 'pt_BR'